//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbRoxManualPrescription from '@/elements/prescription/rb-rox-manual-prescription.vue'
import RbRoxUploadPrescription from '@/elements/prescription/rb-rox-upload-prescription.vue'
import Prescription from '@/scripts/libs/prescription'
import RbModal from '@/elements/modal/rb-modal.vue'
import wcs from '@/scripts/libs/wcs'

export default {
  name: 'rb-rox-prescription',
  components: {
    RbRoxManualPrescription,
    RbRoxUploadPrescription,
    RbModal,
  },
  props: {
    buttonLabel: {
      type: String,
      default: '',
    },
    isButtonIcon: {
      type: Boolean,
      default: true,
    },
    isInfoMessage: {
      type: Boolean,
      default: true,
    },
    isModalEnabled: {
      type: Boolean,
      default: true,
    },
    orderId: {
      type: String,
      default: '',
    },
    orderItemId: {
      type: String,
      default: '',
    },
    withModalPortal: {
      type: Boolean,
      default: false,
    },
  },
  data: () => {
    return {
      isModalVisible: false,
      prescriptionObject: {},
    }
  },
  computed: {
    isInCartPage() {
      return wcs.isInCart()
    },
    isInPaymentPage() {
      return wcs.isInPaymentPage()
    },
    isUploadPrescriptionObject() {
      return Prescription.isUploadPrescriptionObject(this.prescriptionObject)
    },
    messageBoxType() {
      return this.isInfoMessage ? 'info' : 'success'
    },
    modalClassContainer() {
      return this.isUploadPrescriptionObject
        ? 'rb-rox-upload-prescription-modal'
        : 'rb-rox-manual-prescription-modal'
    },
    modalWrapperClass() {
      if (this.isInCartPage) {
        return 'cart'
      }
      return this.isInPaymentPage ? 'rox-prescription' : 'main'
    },
    prescriptionObjectIsPopulated() {
      return Object.keys(this.prescriptionObject).length > 0
    },
  },
  async mounted() {
    this.prescriptionObject = await Prescription.getPrescription(+this.orderId, +this.orderItemId)
  },
  methods: {
    closeModal() {
      this.isModalVisible = false
    },
    openModal() {
      if (this.isModalEnabled) {
        this.isModalVisible = true
      }
    },
  },
}
